var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.855 5.975c.902 0 1.724.409 2.199 1.094.474.686.517 1.525.113 2.246l-4.234 7.561c-.22.391-.666.638-1.156.638H9.146c-.583 0-1.094-.348-1.247-.85L4.28 4.82H2.684c-.715 0-1.292-.516-1.292-1.153s.577-1.154 1.292-1.154h2.585c.583 0 1.093.348 1.247.85l.797 2.611h16.542Zm-3.877 9.232h-9.845L8.018 8.282h15.837l-3.877 6.924ZM8.5 23.284c1.07 0 1.938-.775 1.938-1.731 0-.957-.868-1.731-1.938-1.731-1.07 0-1.939.774-1.939 1.73 0 .957.868 1.732 1.939 1.732Zm12.923 0c1.07 0 1.939-.775 1.939-1.731 0-.957-.869-1.731-1.939-1.731s-1.938.774-1.938 1.73c0 .957.868 1.732 1.938 1.732Z",
  fill: "#00546F"
})));
export default SvgCartIcon;